import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useSuperAdminAuth } from '../../hooks/useSuperAdminAuth';
import { ROUTES } from '../../constants';
import Dropdown from '../ui/Dropdown';
import Icon from '../ui/Icon';
import './SuperAdminHeader.css';

const SuperAdminHeader = ({ onMenuToggle, isSidebarOpen, headerRef }) => {
  const { superAdmin, superAdminLogout } = useSuperAdminAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    superAdminLogout();
    navigate(ROUTES.SUPER_ADMIN_LOGIN);
  };

  const userMenuOptions = [
    {
      value: 'profile',
      label: 'Profile',
      icon: 'person'
    },
    {
      value: 'logout',
      label: 'Logout',
      icon: 'logout'
    }
  ];

  const handleUserMenuSelect = (value) => {
    switch (value) {
      case 'profile':
        navigate(ROUTES.SUPER_ADMIN_PROFILE);
        break;
      case 'logout':
        handleLogout();
        break;
      default:
        break;
    }
  };

  return (
    <header ref={headerRef} className="super-admin-header">
      <div className="super-admin-header-left">
        <button
          className="super-admin-header-menu-toggle"
          onClick={onMenuToggle}
          aria-label="Toggle sidebar"
        >
          <Icon name="menu" size="medium" />
        </button>

        <Link to={ROUTES.SUPER_ADMIN_DASHBOARD} className="super-admin-header-logo">
          <img src="/sks-icons.svg" alt="SKS Pvt" className="super-admin-header-logo-img" />
          <span className="super-admin-header-logo-text">Platform Administrator</span>
        </Link>
      </div>

      <div className="super-admin-header-right">
        {/* User Menu */}
        <div className="super-admin-header-user">
          <Dropdown
            options={userMenuOptions}
            value=""
            onChange={handleUserMenuSelect}
            placeholder=""
            className="super-admin-header-user-dropdown"
            searchable={false}
            clearable={false}
            position="right"
          >
            <div className="super-admin-header-user-info">
              <div className="super-admin-header-user-avatar">
                {superAdmin?.fullName?.charAt(0) || superAdmin?.username?.charAt(0) || 'A'}
              </div>
              <div className="super-admin-header-user-details">
                <div className="super-admin-header-user-name">
                  {superAdmin?.fullName || superAdmin?.username || 'Admin'}
                </div>
                <div className="super-admin-header-user-role">
                  Platform Administrator
                </div>
              </div>
              <Icon name="keyboard_arrow_down" size="small" />
            </div>
          </Dropdown>
        </div>
      </div>
    </header>
  );
};

export default SuperAdminHeader;

